<template>
  <div
    :class="`preloader pls-${$props.color} button-spinner pl-${$props.size}`"
    style="vertical-align: middle"
  >
    <svg class="pl-circular" viewBox="25 25 50 50">
      <circle class="plc-path" cx="50" cy="50" r="20" />
    </svg>
  </div>
</template>

<script>
import { SizeNames } from '@/utils/enum'

export default {
  props: {
    color: { type: String, default: 'blue' },
    size: {
      type: String,
      default: SizeNames.MD,
      validator(value) {
        return Object.values(SizeNames).includes(value)
      },
    },
  },
}
</script>

<style scoped lang="scss">
.button-spinner {
  width: 16px;
  margin-left: -6px;
  margin-right: 6px;
  transition: all 0.3s;
}
.pl-lg {
  width: 20px;
  margin-left: -9px;
  margin-right: 8px;
}
.pl-xs {
  margin-left: 0;
  margin-right: 4px;
  margin-bottom: 0px;
  width: 12px;
}
</style>
